<template>
  <div>
    <Html>
      <Head>
        <Link
          v-if="pageResolver"
          id="slug-can"
          rel="canonical"
          :href="buildUrl(pageResolver.data.locale, pageResolver.data.slug)"
          :hreflang="pageResolver.data.locale"
        />
        <template v-for="link in links" :key="link.id">
          <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
        </template>
      </Head>
      <Body>
        <div v-if="pageResolver?.type === PageResolverType.CATEGORY">
          <CategoryPage :page-resolver="pageResolver" />
        </div>
        <div v-else-if="pageResolver?.type === PageResolverType.PRODUCT">
          <UiNarrowContainer>
            <ProductPage :page-resolver="pageResolver" />
          </UiNarrowContainer>
        </div>
        <div v-else-if="pageResolver?.type === PageResolverType.CMS">
          <Page :page-resolver="pageResolver" />
        </div>
        <div v-else>
          <UiNarrowContainer>
            <div class="flex flex-col gap-6 rounded-xl bg-white p-8 text-center md:m-auto md:size-1/3 md:px-4">
              <UiHeading type="d1" class="!font-medium !text-primary-400">{{ $t('error.404.code') }}</UiHeading>
              <div class="flex flex-col gap-4">
                <UiHeading type="h1">{{ $t('error.404.title') }}</UiHeading>

                <UiText>
                  {{ $t('error.404.description') }}
                </UiText>
              </div>
            </div>
          </UiNarrowContainer>
        </div>
      </Body>
    </Html>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '~/stores/app/appStore';
import { PageResolverType } from '~/stores/app/types';

const { locale } = useI18n();
const route = useRoute();
const runtimeConfig = useRuntimeConfig();

const appStore = useAppStore();

const slugs = ((route.params?.slug ?? []) as string[]).filter((slug) => slug);
const lastSlug = slugs[slugs.length - 1] as string | undefined;

const buildUrl = (locale: Locale, slug: string): string => `${runtimeConfig.public.baseUrl}/${locale}/${slug}`;

const pageResolver = computed(() => appStore.getPageType(lastSlug, locale.value as Locale));

const links = computed(() =>
  pageResolver.value?.data.alternate_slugs
    ? Object.entries(pageResolver.value.data.alternate_slugs).map(([key, value]) => ({
        href: buildUrl(key as Locale, value),
        hreflang: key,
        id: `slug-alt-${key}`,
        rel: 'alternate',
      }))
    : [],
);
</script>
